// extracted by mini-css-extract-plugin
module.exports = {"testFinale":"Tables_testFinale__2GqrY"};